// src/stores/pageHeaderStore.ts
import { create } from 'zustand';
import type { ReactNode } from 'react';

interface PageHeaderState {
  title: string | null;
  icon: ReactNode | null;
  breadcrumbs: { label: string; path: string }[];
  setHeader: (h: { title: string; icon?: ReactNode; breadcrumbs?: { label: string; path: string }[] }) => void;
  clearHeader: () => void;
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  title: null,
  icon: null,
  breadcrumbs: [],
  setHeader: (h) => set({ title: h.title, icon: h.icon ?? null, breadcrumbs: h.breadcrumbs ?? [] }),
  clearHeader: () => set({ title: null, icon: null, breadcrumbs: [] }),
}));
